export default __webpack_public_path__ + "static/media/Image(5).5e945831.png";